// IconButton.tsx
import React, { useRef, useState } from "react";
import { IconButtonProps } from "./IconButton.types";
import { ButtonContainer, ButtonIcon, Tooltip } from "./IconButton.styles";
import TooltipPortal from "../../TooltipPortal/TooltipPortal";

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  href,
  altText,
  tooltip,
}) => {
  const buttonRef = useRef<HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  if (href) {
    return (
      <>
        <ButtonContainer
          as="a"
          href={href}
          ref={buttonRef as React.RefObject<HTMLAnchorElement>}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <ButtonIcon src={icon} alt={altText} />
        </ButtonContainer>
        {tooltip && isHovered && (
          <TooltipPortal targetRef={buttonRef}>
            <Tooltip visible={isHovered}>{tooltip}</Tooltip>
          </TooltipPortal>
        )}
      </>
    );
  }

  return (
    <>
      <ButtonContainer
        as="button"
        onClick={onClick}
        ref={buttonRef as React.RefObject<HTMLButtonElement>}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ButtonIcon src={icon} alt={altText} />
      </ButtonContainer>
      {tooltip && isHovered && (
        <TooltipPortal targetRef={buttonRef}>
          <Tooltip visible={isHovered}>{tooltip}</Tooltip>
        </TooltipPortal>
      )}
    </>
  );
};

export default IconButton;
